import { connect } from 'react-redux';
import { getWatchCount } from '../../../publicSession/selectors';
var mapStateToProps = function (state) { return ({
    watchCount: getWatchCount(state),
}); };
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=WatchButton.container.js.map